
export class ProposalState {
	public proposalPortfolioName: string;
	public metrics: ProposalMetric[] = [];
	public purpose: ProposalPurpose = {
		riskTolerance: '',
		objective: ''
	};
}

export interface ProposalMetric {
	name: string;
	icon?: string;
	componentSectionDependency?: string;
	order?: number;
	overview: string;
}

export interface ProposalPurpose {
	riskTolerance: string;
	objective: string;
}
